package com.merkost.handpass.admin.di

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import org.koin.mp.KoinPlatform

@Composable
inline fun <reified T : Any> koinContainer(): T = remember { KoinPlatform.getKoin().get<T>() }
